import * as React from 'react';
import {useEffect , useState} from "react"
import './styles.css'
import {useDispatch, useSelector} from "react-redux";
import {Util,Header} from 'baziigram'
import {GetUser} from "../../Util/user"
import {HOME_ACTION_CLEAR} from "../../redux/Home/home.constant";
import {IFRAME_ACTION_CLEAR} from "../../redux/Iframe/iframe.constant";
import {GAME_USER_PROFILE_ACTION_CLEAR} from "../../redux/GameUserProfile/gameUserProfile.constant";

const GameHeader =({children , headerImage , type}) => {

const [leftImage , setLeftImage] = useState({img:"/images/main-page/moon6.png" , class:"moon"})
const mainPages = [HOME_ACTION_CLEAR,IFRAME_ACTION_CLEAR,GAME_USER_PROFILE_ACTION_CLEAR , "ABOUT_US" , "AWARDS"]

useEffect(()=>{
        let user = GetUser()
        if(user &&  user.theme=="day")
        {setLeftImage({img:"/images/main-page/sun.png",class:"sun"})
        document.getElementsByTagName('body')[0].classList.add('light-background')
        }

    },[])


return (  <>{mainPages.indexOf(type)==-1 &&
             <Header headerLeftImage={leftImage.img} leftImageClass={leftImage.class} rightImageClass={" phoenix"}
               headerRightImage={headerImage}>
                 {children}
               </Header>
               }
        {mainPages.indexOf(type)>-1 &&
          <header lang={Util.getLanguage()} class={"main-header"}>
          <div className={"header-description-horizontal"}>
                  {children}
               </div>
                     <div className={"gif-container "}>
                    <img   className="gif-image" src="/images/main-page/Untitled_Artwork 11 (2) (3).gif" />
                      </div>

            </header>
          }
          </>
        )

}
GameHeader.defaultProps = {
    headerImage:"/images/main-page/phoenix-header2.png"
};
export default GameHeader